import styled from "styled-components";

const ResultDiv = styled.div`
  color:#c0c0c0;
  height:35%;
  font-size:1.5rem;
`;


const Result = ({ result }) => {
  return (
    <ResultDiv>
      {result}
    </ResultDiv>
  );
};

export default Result;